import { getDefaultExportFromCjs as n } from "./main9.js";
import { _ as o } from "./main10.js";
var u = o;
function f(e, r, a) {
  var t = e == null ? void 0 : u(e, r);
  return t === void 0 ? a : t;
}
var s = f;
const l = /* @__PURE__ */ n(s);
export {
  l as default
};
